import { FormItemProps } from "@app/components/forms/types/props";
import {
  OtherSchema,
  TextInputSchema,
} from "@app/components/forms/types/schema";
import {
  Checkbox,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "@shortsworks/ui";
import { cn } from "@shortsworks/ui/lib/utils";
import { useEffect } from "react";

export const FormCheckbox = (props: FormItemProps<OtherSchema>) => {
  const { form, schema, ...rest } = props;

  useEffect(() => {
    if (
      form.getValues(schema.id) === undefined ||
      form.getValues(schema.id) === ""
    ) {
      form.setValue(schema.id, false);
    }
  }, []);

  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => (
        <FormItem
          className={cn(
            "flex flex-row items-start space-x-3 space-y-0",
            schema.appearance?.className,
            schema.appearance?.border ? "rounded-lg border p-3 shadow-sm" : "",
          )}
        >
          <FormControl>
            <Checkbox
              className="mt-[0.06rem]"
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel>
              {typeof schema.label === "function"
                ? schema.label(form.getValues())
                : schema.label}
            </FormLabel>
            {schema.description && (
              <FormDescription>
                {typeof schema.description === "function"
                  ? schema.description(form.getValues())
                  : schema.description}
              </FormDescription>
            )}
          </div>
        </FormItem>
      )}
    />
  );
};
